import { Link } from 'react-router-dom';
import { hotComics, newComics } from '@/mocks/comics';

const coverImages: Record<string, string> = {
  'secret-class': 'https://readdy.ai/api/search-image?query=Secret%20Class%20Korean%20manga%20cover%20art%20illustration%20with%20soft%20romantic%20atmosphere%20warm%20lighting%20elegant%20composition&width=440&height=587&seq=comic-cover-01&orientation=portrait',
  'demon-king': 'https://readdy.ai/api/search-image?query=Demon%20King%20Returns%20Korean%20manga%20cover%20dramatic%20fantasy%20scene%20dark%20atmosphere%20powerful%20character%20illustration&width=440&height=587&seq=comic-cover-02&orientation=portrait',
  'star-romance': 'https://readdy.ai/api/search-image?query=Star%20Romance%20Korean%20manga%20cover%20beautiful%20couple%20under%20starry%20night%20sky%20romantic%20dreamy%20atmosphere%20soft%20colors&width=440&height=587&seq=comic-cover-06&orientation=portrait',
  'dark-detective': 'https://readdy.ai/api/search-image?query=Dark%20Detective%20Korean%20manga%20mystery%20noir%20cover%20atmospheric%20dark%20city%20street%20detective%20silhouette%20illustration&width=440&height=587&seq=comic-cover-04&orientation=portrait',
  'action-hero': 'https://readdy.ai/api/search-image?query=Fighting%20King%20Korean%20action%20manga%20cover%20dynamic%20martial%20arts%20scene%20powerful%20character%20intense%20battle%20illustration&width=440&height=587&seq=comic-cover-05&orientation=portrait',
  'magic-academy': 'https://readdy.ai/api/search-image?query=Magic%20Academy%20Korean%20fantasy%20manga%20cover%20grand%20magical%20school%20students%20casting%20spells%20enchanting%20atmosphere%20illustration&width=440&height=587&seq=comic-cover-11&orientation=portrait',
  'fantasy-world': 'https://readdy.ai/api/search-image?query=Isekai%20Reincarnation%20Korean%20fantasy%20manga%20cover%20magical%20world%20portal%20adventure%20colorful%20vibrant%20illustration&width=440&height=587&seq=comic-cover-07&orientation=portrait',
  'school-fight': 'https://readdy.ai/api/search-image?query=School%20Fight%20Korean%20action%20manga%20cover%20students%20battle%20scene%20dynamic%20schoolyard%20setting%20energetic%20illustration&width=440&height=587&seq=comic-cover-09&orientation=portrait',
  'crime-city': 'https://readdy.ai/api/search-image?query=Crime%20City%20Korean%20noir%20suspense%20manga%20cover%20dark%20urban%20landscape%20gritty%20crime%20scene%20intense%20thriller%20illustration&width=440&height=587&seq=comic-cover-12&orientation=portrait',
  'love-signal': 'https://readdy.ai/api/search-image?query=Love%20Signal%20Korean%20romance%20manga%20cover%20sweet%20couple%20illustration%20pastel%20colors%20dreamy%20atmosphere&width=440&height=587&seq=comic-cover-03&orientation=portrait',
  'mystery-house': 'https://readdy.ai/api/search-image?query=Mystery%20House%20Korean%20horror%20suspense%20manga%20cover%20eerie%20mansion%20dark%20atmosphere%20chilling%20thriller%20illustration&width=440&height=587&seq=comic-cover-08&orientation=portrait',
  'office-romance': 'https://readdy.ai/api/search-image?query=Office%20Romance%20Korean%20manga%20cover%20elegant%20workplace%20setting%20professional%20couple%20romantic%20tension%20sophisticated%20illustration&width=440&height=587&seq=comic-cover-10&orientation=portrait',
};

interface ComicCardProps {
  id: string;
  title: string;
  slug: string;
  status: string;
  latestChapter: string;
  imageUrl: string;
}

function ComicCard({ id, title, slug, status, latestChapter, imageUrl }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${slug}`}
      className="flex-shrink-0 w-[200px] md:w-[220px] group cursor-pointer"
    >
      <div className="aspect-[3/4] rounded-xl overflow-hidden bg-background-200 mb-3">
        <img
          src={imageUrl}
          alt={`${title} - 韩国漫画`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
          loading="lazy"
        />
      </div>
      <div className="px-1">
        <h3 className="font-heading text-base font-bold text-foreground-950 truncate mb-1">
          {title}
        </h3>
        <p className="text-xs text-foreground-500 flex items-center gap-2">
          <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
            status === '连载中' ? 'bg-accent-100 text-accent-700' : 'bg-secondary-100 text-secondary-700'
          }`}>
            {status}
          </span>
          <span className="truncate">{latestChapter}</span>
        </p>
      </div>
    </Link>
  );
}

export default function HotRecommend() {
  const hotCards = hotComics.map((comic) => ({
    id: comic.id,
    title: comic.title,
    slug: comic.slug,
    status: comic.status,
    latestChapter: comic.chapters[0]?.title || '',
    imageUrl: coverImages[comic.id] || '',
  }));

  const newCards = newComics.map((comic) => ({
    id: comic.id,
    title: comic.title,
    slug: comic.slug,
    status: comic.status,
    latestChapter: comic.chapters[0]?.title || '',
    imageUrl: coverImages[comic.id] || '',
  }));

  return (
    <section className="bg-foreground-950 py-16 md:py-20">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col md:flex-row md:items-end gap-4 mb-10">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-700 text-foreground-300 text-xs font-medium mb-4 whitespace-nowrap">
              热门推荐
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
              本周热门韩漫
              <span className="text-accent-400"> · 不容错过</span>
            </h2>
          </div>
          <Link
            to="/category/love"
            className="text-foreground-500 hover:text-white text-sm transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {hotCards.map((card) => (
            <ComicCard key={card.id} {...card} />
          ))}
        </div>
      </div>

      <div className="w-full px-4 md:px-6 mt-16">
        <div className="flex flex-col md:flex-row md:items-end gap-4 mb-10">
          <div className="flex-1">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-700 text-foreground-300 text-xs font-medium mb-4 whitespace-nowrap">
              最新上架
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-white leading-tight">
              最新韩漫更新
              <span className="text-secondary-400"> · 新鲜出炉</span>
            </h2>
          </div>
          <Link
            to="/category/action"
            className="text-foreground-500 hover:text-white text-sm transition-colors flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm w-4 h-4 flex items-center justify-center" />
          </Link>
        </div>

        <div className="flex gap-5 overflow-x-auto pb-4" style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          {newCards.map((card) => (
            <ComicCard key={card.id} {...card} />
          ))}
        </div>
      </div>
    </section>
  );
}